/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const {Content, Row, Column, Markup, FormCustom, FormRow, InputText, InputEmail, InputPhone, InputDropdown, OptionDropdown, RadioGroup, InputRadio, InputTextarea, FormButton} = Object.assign({}, _provideComponents(), props.components);
  if (!Column) _missingMdxReference("Column", true);
  if (!Content) _missingMdxReference("Content", true);
  if (!FormButton) _missingMdxReference("FormButton", true);
  if (!FormCustom) _missingMdxReference("FormCustom", true);
  if (!FormRow) _missingMdxReference("FormRow", true);
  if (!InputDropdown) _missingMdxReference("InputDropdown", true);
  if (!InputEmail) _missingMdxReference("InputEmail", true);
  if (!InputPhone) _missingMdxReference("InputPhone", true);
  if (!InputRadio) _missingMdxReference("InputRadio", true);
  if (!InputText) _missingMdxReference("InputText", true);
  if (!InputTextarea) _missingMdxReference("InputTextarea", true);
  if (!Markup) _missingMdxReference("Markup", true);
  if (!OptionDropdown) _missingMdxReference("OptionDropdown", true);
  if (!RadioGroup) _missingMdxReference("RadioGroup", true);
  if (!Row) _missingMdxReference("Row", true);
  return React.createElement(React.Fragment, null, React.createElement(Content, {
    noBorder: true,
    className: "container-wide my-xxl-8 mt-6 pb-8 h-100 d-flex"
  }, React.createElement(Row, null, React.createElement(Column, {
    className: "col-lg-5 col-5 p-0 position-absolute h-100"
  }, React.createElement(Markup, {
    html: "<div id=\"workshop\"><img class=\"w-100\" src=\"https://www.macu.com/media/inline/inline-boat-v2cc-1024x768.jpg\" alt=\"man piloting boat\" /></div>"
  })), React.createElement(Column, {
    className: "col-lg-8 col-sm-10 mx-auto my-lg-8 mt-6 p-xl-6 p-lg-5 p-4 shadow blur bg-fuzzyGray z-indexer"
  }, React.createElement(Markup, {
    html: "<div class=\"pb-4 row\">    <div class=\"col-sm-8\">        <h1>Let\'s Connect</h1>        <p>Fill out the form below to have an experienced member of our wealth management team reach out at a time that works best for you.</p>    </div>    <div class=\"col-sm-4 investments-logo w-100 py-3\">    <img class=\"w-100\" style=\"max-width:250px;\" src=\"https://www.macu.com/media/logos/investments-color-logo.svg\" />    </div></div>",
    cssStyle: ".absolutelyRight {    position:absolute;    right:0px;}.z-indexer{    z-index:9;}.bg-fuzzyGray {    background-color: rgba(255, 255, 255, 0.6);}.customHeight {    max-height:300px;    overflow:scroll;}.investments-logo {    width: 100%;    text-align: center;    margin: 0px auto;}"
  }), React.createElement(FormCustom, {
    formName: "wmp-contactus",
    formAction: "https://s2213.t.eloqua.com/e/f2",
    eloquaSiteId: "2213",
    className: "grayForm"
  }, React.createElement(FormRow, null, React.createElement(InputText, {
    inputLabel: "First name",
    inputFieldName: "firstName",
    inputRequired: true,
    className: "col-lg-6 pr-lg-4"
  }), React.createElement(InputText, {
    inputLabel: "Last name",
    inputFieldName: "lastName",
    className: "col-lg-6"
  })), React.createElement(FormRow, null, React.createElement(InputEmail, {
    inputLabel: "Email address",
    inputFieldName: "emailAddress",
    inputRequired: true,
    className: "col-lg-6 pr-lg-4",
    inputType: "email"
  }), React.createElement(InputPhone, {
    inputLabel: "Phone",
    inputFieldName: "busPhone",
    className: "col",
    inputType: "tel"
  })), React.createElement(FormRow, {
    className: "mb-4"
  }, React.createElement(InputText, {
    inputLabel: "City",
    inputFieldName: "city",
    className: "col"
  }), React.createElement(InputDropdown, {
    title: "State",
    name: "stateProv",
    className: "col-lg-6 pb-3 text-primary",
    visibleItems: "10"
  }, React.createElement(OptionDropdown, {
    text: "Alaska"
  }), React.createElement(OptionDropdown, {
    text: "Alabama"
  }), React.createElement(OptionDropdown, {
    text: "Arkansas"
  }), React.createElement(OptionDropdown, {
    text: "Arizona"
  }), React.createElement(OptionDropdown, {
    text: "California"
  }), React.createElement(OptionDropdown, {
    text: "Colorado"
  }), React.createElement(OptionDropdown, {
    text: "Connecticut"
  }), React.createElement(OptionDropdown, {
    text: "D.C."
  }), React.createElement(OptionDropdown, {
    text: "Delaware"
  }), React.createElement(OptionDropdown, {
    text: "Florida"
  }), React.createElement(OptionDropdown, {
    text: "Georgia"
  }), React.createElement(OptionDropdown, {
    text: "Hawaii"
  }), React.createElement(OptionDropdown, {
    text: "Iowa"
  }), React.createElement(OptionDropdown, {
    text: "Idaho"
  }), React.createElement(OptionDropdown, {
    text: "Illinois"
  }), React.createElement(OptionDropdown, {
    text: "Indiana"
  }), React.createElement(OptionDropdown, {
    text: "Kansas"
  }), React.createElement(OptionDropdown, {
    text: "Kentucky"
  }), React.createElement(OptionDropdown, {
    text: "Louisiana"
  }), React.createElement(OptionDropdown, {
    text: "Massachusetts"
  }), React.createElement(OptionDropdown, {
    text: "Maryland"
  }), React.createElement(OptionDropdown, {
    text: "Maine"
  }), React.createElement(OptionDropdown, {
    text: "Michigan"
  }), React.createElement(OptionDropdown, {
    text: "Minnesota"
  }), React.createElement(OptionDropdown, {
    text: "Missouri"
  }), React.createElement(OptionDropdown, {
    text: "Mississippi"
  }), React.createElement(OptionDropdown, {
    text: "Montana"
  }), React.createElement(OptionDropdown, {
    text: "North Carolina"
  }), React.createElement(OptionDropdown, {
    text: "North Dakota"
  }), React.createElement(OptionDropdown, {
    text: "Nebraska"
  }), React.createElement(OptionDropdown, {
    text: "New Hampshire"
  }), React.createElement(OptionDropdown, {
    text: "New Jersey"
  }), React.createElement(OptionDropdown, {
    text: "New Mexico"
  }), React.createElement(OptionDropdown, {
    text: "Nevada"
  }), React.createElement(OptionDropdown, {
    text: "New York"
  }), React.createElement(OptionDropdown, {
    text: "Ohio"
  }), React.createElement(OptionDropdown, {
    text: "Oklahoma"
  }), React.createElement(OptionDropdown, {
    text: "Oregon"
  }), React.createElement(OptionDropdown, {
    text: "Pennsylvania"
  }), React.createElement(OptionDropdown, {
    text: "Rhode Island"
  }), React.createElement(OptionDropdown, {
    text: "South Carolina"
  }), React.createElement(OptionDropdown, {
    text: "South Dakota"
  }), React.createElement(OptionDropdown, {
    text: "Tennessee"
  }), React.createElement(OptionDropdown, {
    text: "Texas"
  }), React.createElement(OptionDropdown, {
    text: "Utah"
  }), React.createElement(OptionDropdown, {
    text: "Virginia"
  }), React.createElement(OptionDropdown, {
    text: "Vermont"
  }), React.createElement(OptionDropdown, {
    text: "Washington"
  }), React.createElement(OptionDropdown, {
    text: "Wisconsin"
  }), React.createElement(OptionDropdown, {
    text: "West Virginia"
  }), React.createElement(OptionDropdown, {
    text: "Wyoming"
  }))), React.createElement(FormRow, null, React.createElement(RadioGroup, {
    title: "What is the best time to contact you?",
    groupName: "radioButtons",
    groupClassName: "col mb-4"
  }, React.createElement(InputRadio, {
    inputLabel: "9 a.m.–12 p.m.",
    inputClassName: "col-3"
  }), React.createElement(InputRadio, {
    inputLabel: "12–3 p.m.",
    inputClassName: "col-3"
  }), React.createElement(InputRadio, {
    inputLabel: "3–6 p.m.",
    inputClassName: "col-3"
  }), React.createElement(InputRadio, {
    inputLabel: "After 6 p.m.",
    inputClassName: "col-3"
  }))), React.createElement(FormRow, null, React.createElement(InputDropdown, {
    title: "Inquiry subject",
    name: "inquiryType",
    className: "col mb-4",
    visibleItems: "0"
  }, React.createElement(OptionDropdown, {
    text: "401(k) Rollovers"
  }), React.createElement(OptionDropdown, {
    text: "Estate Planning"
  }), React.createElement(OptionDropdown, {
    text: "Medicare"
  }), React.createElement(OptionDropdown, {
    text: "Retirement Planning"
  }), React.createElement(OptionDropdown, {
    text: "Social Security Planning"
  }), React.createElement(OptionDropdown, {
    text: "Vendor Inquiry"
  }), React.createElement(OptionDropdown, {
    text: "Other"
  }))), React.createElement(FormRow, null, React.createElement(InputTextarea, {
    inputLabel: "How can we help you?",
    inputFieldName: "helpyou",
    className: "col mb-4",
    rows: 1
  })), React.createElement(FormRow, null, React.createElement(FormButton, {
    buttonText: "Submit",
    buttonType: "submit",
    className: "btn btn-primary"
  })))), React.createElement(Column, {
    className: "col-lg-5 col-sm-6 col-5 p-0 d-flex h-100 flex-column justify-content-end absolutelyRight"
  }, React.createElement(Markup, {
    html: "<img class=\"w-100\" src=\"https://www.macu.com/media/inline/inline-aerial-ocean-1024x768.jpg\" alt=\"view of the ocean from space\" />"
  })))), "\n", React.createElement(Content, {
    noBorder: true,
    className: "py-6"
  }, React.createElement(Row, null, React.createElement(Column, {
    className: "px-xl-6 px-lg-5 px-4"
  }, React.createElement(Markup, {
    html: "<p>Check the background of this firm on <a href=\"http://brokercheck.finra.org/Firm/6413\" target=\"_blank\">FINRA\'s BrokerCheck</a>.</p><br/><br/>{{settings.lpl_footer_disclosure_html.value}}"
  })))));
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
